module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('h1', [_vm._v("Imprint")]), _vm._v(" "), _c('p', [_vm._v("\n    This site is made and run by Merten Hanisch"), _c('br'), _vm._v("\n    Contact:\n    "), _c('a', {
    attrs: {
      "href": "mailto:merten.hanisch@gmail.com"
    }
  }, [_vm._v("merten.hanisch@gmail.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c3149ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/imprint.vue
// module id = 81
// module chunks = 1